import React, { useState } from 'react';
import { connect } from 'react-redux';

import { t } from 'i18n';

import ActionButton from 'Components/Base/ActionButton';
import CodeInputWithExpiry from 'Components/Base/Code/CodeInputWithExpiry';
import validateCode from './validateCode';

import verifyEmailByCodeAndRegister from '../verifyEmailByCodeAndRegister';
import resendConfirmationEmail from '../resendConfirmationEmail';

const i18nOpts = { scope: 'registration.email_confirmation_modal' };

const ResendCodeContent = ({
  resendConfirmationEmailUrl,
  resendStatus,
  setResendStatus,
}) => {
  switch (resendStatus) {
    case 'loading':
      return t('sending', i18nOpts);
    case 'success':
      return t('sent', i18nOpts);
    case 'default':
    case 'error':
    default:
      return <a onClick={() => resendConfirmationEmail(resendConfirmationEmailUrl, { setResendStatus })}>
        {t('resend', i18nOpts)}
      </a>;
  }
};

const CodeInfoContent = ({
  errorType,
  setErrorType,
  resendConfirmationEmailUrl,
}) => {
  const [resendStatus, setResendStatus] = useState('default');

  switch (errorType) {
    case 'validation':
      return <div className="registrationV2__form_body__api_error">
        {`${t('incorrect_code', i18nOpts)} `}
        <a onClick={() => {
          setErrorType(null);
          resendConfirmationEmail(resendConfirmationEmailUrl);
        }}>
          {t('incorrect_code_resend', i18nOpts)}
        </a>.
      </div >;
    case 'expired':
      return <div className="registrationV2__form_body__api_error">
        {`${t('expired_code', i18nOpts)} `}
        <a onClick={() => {
          setErrorType(null);
          resendConfirmationEmail(resendConfirmationEmailUrl);
        }}>
          {t('expired_code_resend', i18nOpts)}
        </a>.
      </div>;
    default:
      return <>
        <div>
          {`${t('no_email', i18nOpts)} `}
          <ResendCodeContent
            resendConfirmationEmailUrl={resendConfirmationEmailUrl}
            resendStatus={resendStatus}
            setResendStatus={setResendStatus}
          />
        </div>
        {resendStatus === 'error' && <div className="registrationV2__form_body__api_error">
          {t('resend_error', i18nOpts)}
        </div>}
      </>;;
  }
};

const CodeInput = ({
  resendConfirmationEmailUrl,
  registrationUrl,
  setStep,
  errorType,
  setErrorType,
  user,
}) => {
  const [code, setCode] = useState('');

  return <>
    <div className="registrationV2__email_confirmation_modal__body">
      <h3 className="registrationV2__email_confirmation_modal__header">{t('header', i18nOpts)}</h3>
      <div className="registrationV2__email_confirmation_modal__info">
        {user.email
          ? <>
            {`${t('verification_email', i18nOpts)} `}
            <b>{user.email}</b>.
          </>
          : t('verification_you', i18nOpts)}
        <br />
        {t('description', i18nOpts)}
      </div>
      <div className="registrationV2__email_confirmation_modal__code">
        <CodeInputWithExpiry
          onChange={setCode}
          isError={!!errorType}
        />
      </div>
      <div className="registrationV2__email_confirmation_modal__comment">
        <CodeInfoContent
          errorType={errorType}
          setErrorType={setErrorType}
          resendConfirmationEmailUrl={resendConfirmationEmailUrl}
        />
        <div>{t('check_spam', i18nOpts)}</div>
      </div>
    </div>
    <div className="ModalV2__footer">
      <div className="action_modal__footer">
        <ActionButton
          content={t('verify_email', i18nOpts)}
          onClick={() => {
            if (!validateCode(code)) {
              setErrorType('form_validation');
              return;
            }

            verifyEmailByCodeAndRegister(
              code,
              registrationUrl,
              setErrorType,
              setStep,
            );
          }}
        />
      </div>
    </div>
  </>;
};

const mapStateToProps = ({ signupPage: { user } }) => ({
  user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CodeInput);
